module.exports = __webpack_public_path__ + "img/wanglai.a5abd1f6.png";